// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__sm727","filesListContainer":"PosDisputesFiles_filesListContainer__myBq-","filesButton":"PosDisputesFiles_filesButton__1NW4N"};